import { apiServiceInstance } from '@/core/helpers/utils';
import {
  ApiResponse,
  ApiResponseWithExtra,
  CaiDatLoaiGiaTri,
  ICaiDatCreateResponse,
  ICaiDatItem,
  ICaiDatListExtra,
  ICaiDatTuyChon,
} from '@/core/interfaces/ApiResponses';

const JSON_HEADERS = { 'Content-Type': 'application/json' };

export type CaiDatCreatePayload = {
  khoa: string;
  loai_gia_tri?: CaiDatLoaiGiaTri;
  gia_tri?: string;
  ghi_chu?: string;
  tuy_chon?: ICaiDatTuyChon[];
};

export type CaiDatUpdatePayload = {
  gia_tri?: string;
  ghi_chu?: string;
};

export class CaiDatService {
  static list(options?: { all?: boolean }): Promise<{
    data: ApiResponseWithExtra<ICaiDatItem[], ICaiDatListExtra>;
  }> {
    return apiServiceInstance().vueInstance.axios.get(
      '/api/v1/cai-dat/danh-sach',
      {
        params: options?.all ? { all: 1 } : undefined,
      }
    );
  }

  static create(payload: CaiDatCreatePayload): Promise<{
    data: ApiResponse<ICaiDatCreateResponse>;
  }> {
    return apiServiceInstance().vueInstance.axios.post(
      '/api/v1/cai-dat/tao-moi',
      payload,
      { headers: JSON_HEADERS }
    );
  }

  static update(
    id: number,
    payload: CaiDatUpdatePayload
  ): Promise<{
    data: ApiResponse<ICaiDatItem>;
  }> {
    return apiServiceInstance().vueInstance.axios.post(
      `/api/v1/cai-dat/cap-nhat/${id}`,
      payload,
      { headers: JSON_HEADERS }
    );
  }
}
